import { render, staticRenderFns } from "./_gymName.vue?vue&type=template&id=5e10d2db"
import script from "./_gymName.vue?vue&type=script&lang=js"
export * from "./_gymName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports